swiper = new Swiper('.hero-slider', {
	updateOnWindowResize: true,
	centeredSlides: true,
	slidesPerColumnFill: 'row',
	slidesPerView: 1,
	spaceBetween: 0,
	loop: true,
	autoplay: {
		delay: 7000,
		disableOnInteraction: false,
	},
	keyboard: {
		enabled: true,
		onlyInViewport: false,
	},
	navigation: {
		prevEl: '.swiper-button-prev',
		nextEl: '.swiper-button-next'
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true
	},
	grabCursor: true
});

// Related pages & posts
swiper = new Swiper('.related-pages.swiper-slider, .related-posts.swiper-slider', {
	observeSlideChildren: true,
	slideToClickedSlide: true,
	updateOnWindowResize: true,
	slidesPerView: 3,
	spaceBetween: 30,
	loop: true,
	breakpoints: {
		320: {
			slidesPerView: 1
		},
		760: {
			slidesPerView: 2
		},
		992: {
			slidesPerView: 3
		}
	},
	autoplay: {
		delay: 7000,
		disableOnInteraction: false,
	},
	keyboard: {
		enabled: true,
		onlyInViewport: false,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	grabCursor: true
});

// Default Row Slider section
$('.wp-block-wp-row-section.slider-section:not(.slider-section--norepeat) > .row').addClass('swiper-wrapper');
$('.wp-block-wp-row-section.slider-section:not(.slider-section--norepeat) > .row > .wp-block-wp-column').addClass('swiper-slide');
$('.wp-block-wp-row-section.slider-section:not(.slider-section--norepeat)').append('<div class="swiper-slider-section-nav"><div class="swiper-button-prev"></div><div class="swiper-pagination"></div><div class="swiper-button-next"></div></div>');
setTimeout(function() {
	swiper = new Swiper('.wp-block-wp-row-section.slider-section:not(.slider-section--norepeat)', {
		observeSlideChildren: true,
		slideToClickedSlide: true,
		updateOnWindowResize: true,
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			760: {
				slidesPerView: 1
			},
			992: {
				slidesPerView: 1.5
			}
		},
		// autoplay: {
		// 	disableOnInteraction: false,
		// 	pauseOnMouseEnter: true,
		// },
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		pagination: {
			el: '.swiper-slider-section-nav .swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-slider-section-nav .swiper-button-next',
			prevEl: '.swiper-slider-section-nav .swiper-button-prev',
		},
		grabCursor: true
	});

	// 	swiper = new Swiper('.section__brands .wp-block-wp-row-section.slider-section', {
	// 		breakpoints: {
	// 			320: {
	// 				slidesPerView: 1
	// 			},
	// 			760: {
	// 				slidesPerView: 3
	// 			},
	// 			992: {
	// 				slidesPerView: 3
	// 			}
	// 		},
	// 		pagination: false,
	// 		loop: false
	// 	});
	// }, 200);

}, 500);

// Default Row Slider section
$('.wp-block-wp-row-section.slider-section.slider-section--norepeat > .row').addClass('swiper-wrapper');
$('.wp-block-wp-row-section.slider-section.slider-section--norepeat > .row > .wp-block-wp-column').addClass('swiper-slide');
$('.wp-block-wp-row-section.slider-section.slider-section--norepeat').append('<div class="swiper-slider-section-nav"><div class="swiper-button-prev"></div><div class="swiper-pagination"></div><div class="swiper-button-next"></div></div>');
setTimeout(function() {
	swiper = new Swiper('.wp-block-wp-row-section.slider-section.slider-section--norepeat', {
		observeSlideChildren: true,
		slideToClickedSlide: true,
		updateOnWindowResize: true,
		slidesPerView: 1,
		spaceBetween: 0,
		loop: false,
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			760: {
				slidesPerView: 2
			},
			992: {
				slidesPerView: 3
			}
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		pagination: {
			el: '.swiper-slider-section-nav .swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-slider-section-nav .swiper-button-next',
			prevEl: '.swiper-slider-section-nav .swiper-button-prev',
		},
		grabCursor: true
	});

}, 500);